import React, { useEffect, useId, useRef } from "react";
import "../styles/StatusResultModal.css";

function ConfirmModal({
  open = false,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  zIndex,
}) {
  const titleId = useId();
  const cancelRef = useRef(null);
  const onCancelRef = useRef(onCancel);
  const lockedRef = useRef(false);

  onCancelRef.current = onCancel;

  useEffect(() => {
    if (!open) return undefined;

    lockedRef.current = false;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onCancelRef.current();
    };
    document.addEventListener("keydown", onKeyDown);
    const focusId = window.setTimeout(() => cancelRef.current?.focus(), 0);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      window.clearTimeout(focusId);
    };
  }, [open]);

  if (!open) return null;

  const handleConfirm = () => {
    if (lockedRef.current) return;
    lockedRef.current = true;
    onConfirm();
  };

  return (
    <div
      className="generate-modal-backdrop"
      style={zIndex != null ? { zIndex } : undefined}
      onClick={onCancel}
    >
      <div
        className="generate-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="generate-modal-header generate-modal-warning">
          <h3 id={titleId} className="generate-modal-title">
            {title}
          </h3>
          <button
            type="button"
            className="generate-modal-close"
            aria-label={cancelLabel}
            onClick={onCancel}
          >
            ×
          </button>
        </div>
        <div className="generate-modal-body">
          {message ? <p className="generate-modal-message">{message}</p> : null}
          <div className="generate-modal-actions">
            <button
              type="button"
              className="generate-modal-btn generate-modal-btn-cancel"
              ref={cancelRef}
              onClick={onCancel}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              className="generate-modal-btn generate-modal-btn-danger"
              onClick={handleConfirm}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
